<template>
  <div class="container">
    <my-nav-ui :idx="4"></my-nav-ui>
    <div class="bottom">
      <div class="left">
        <div class="row1">
          <div class="image">
            <div class="content">
              <div class="tabContent">
                <div class="elevator-frame" v-if="currentRunTabIndex==0">
                  <iframe
                    id="dataFrame"
                    ref="frameRef"
                    src="/static/index2.html"
                    style="width:317px;height:330px;border:0px;margin-top:calc(50% - 150px)"
                    scrolling="no"
                  />
                </div>
                <div>
                  运行动画
                </div>
                <div class="tabContentItem" v-if="currentRunTabIndex==1">
                  <div class="runInfoBox">
                    <div class="runInfo">
                      <span class="runInfoLable" style="text-align:center">救援识别码</span>
                      <span class="runInfoValue">{{runData.fixing.identificationCode}}</span>
                    </div>
                  </div>
                  <div class="runInfoBox">
                    <div class="runInfo">
                      <span class="runInfoLable">方向</span>
                      <span class="runInfoValue">{{runData.dahstateStr}}</span>
                    </div>
                    <div class="runInfo">
                      <span class="runInfoLable">电瓶车</span>
                      <span
                        :class="runData.bicyclestateStr==='有'?'runInfoValue runInfoValueColor1':'runInfoValue'"
                      >{{runData.bicyclestateStr}}</span>
                    </div>
                  </div>
                  <div class="runInfoBox">
                    <div class="runInfo">
                      <span class="runInfoLable">楼层</span>
                      <span class="runInfoValue">{{runData.floorstateStr}}</span>
                    </div>
                    <div class="runInfo">
                      <span class="runInfoLable">是否有人</span>
                      <span
                        :class="runData.peoplestateStr==='有人'?'runInfoValue runInfoValueColor1':'runInfoValue'"
                      >{{runData.peoplestateStr}}</span>
                    </div>
                  </div>
                  <div class="runInfoBox">
                    <div class="runInfo">
                      <span class="runInfoLable">男女比例</span>
                      <span class="runInfoValue">{{runData.peoplesexscaleStr}}</span>
                    </div>
                    <div class="runInfo">
                      <span class="runInfoLable">轿厢情况</span>
                      <span class="runInfoValue">{{runData.doorstateStr}}</span>
                    </div>
                  </div>
                  <div class="runInfoBox">
                    <div class="runInfo">
                      <span class="runInfoLable">当前人数</span>
                      <span class="runInfoValue">{{runData.currentpeopleStr}}</span>
                    </div>
                    <div class="runInfo">
                      <span class="runInfoLable">平层状态</span>
                      <span
                        :class="runData.flatstateStr==='平层'?'runInfoValue runInfoValueColor1':'runInfoValue'"
                      >{{runData.flatstateStr}}</span>
                    </div>
                  </div>
                  <div class="runInfoBox">
                    <div class="runInfo">
                      <span class="runInfoLable">当日人次</span>
                      <span class="runInfoValue">{{runData.inpeopleStr}}</span>
                    </div>
                    <div class="runInfo">
                      <span class="runInfoLable">电梯状态</span>
                      <span
                        :class="runData.runstateStr==='停止'?'runInfoValue runInfoValueColor1':'runInfoValue'"
                      >{{runData.runstateStr}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="video">
            <div class="video-bg" style="height:calc(100%  - 60px);width:100%;">
              <my-video
                v-if="videoId"
                :type="1"
                :v-key="videoId"
                style="height:100%;margin-top:10px;"
              />
            </div>
            <img src="../../static/play.png" v-if="!isVideoPlay" @click="startVideo()" />
            <img src="../../static/stop.png" v-if="isVideoPlay" @click="endVideo()" />
          </div>
        </div>
        <div class="row2">
          <div
            class="content2"
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="#121D49"
          >
            <baidu-map
              class="map"
              :zoom="zoom"
              :center="center"
              @ready="handler"
            >
              <bm-marker :position="markerPoint" :dragging="true" @click="infoWindowOpen">
                <bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen">{{DetailData.fixingName}}</bm-info-window>
              </bm-marker>
            </baidu-map>
          </div>
          <div
            class="content1"
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="#121D49"
          >
            <label class="title">电梯基本情况及技术参数</label>
            <div class="line" v-if="DetailData">
              <span>救援识别码</span>
              <span v-if="DetailData.fixing">{{DetailData.fixing.identificationCode}}</span>
              <span>项目名称</span>
              <span>{{DetailData.fixingName}}</span>
            </div>
            <div class="line" v-if="DetailData">
              <span>设备种类</span>
              <span>{{DetailData.className }}</span>
              <span>设备位置</span>
              <span>{{DetailData.position }}</span>
            </div>
            <div class="line" v-if="DetailData">
              <span>设备品牌</span>
              <span>{{DetailData.brandName}}</span>
              <span>使用场所名称</span>
              <span>{{DetailData.usePlaceName}}</span>
            </div>
            <div class="line" v-if="DetailData">
              <span>人工报警数</span>
              <span>{{DetailData.alarmingCount}}起</span>
              <span>故障报警数</span>
              <span>{{DetailData.faultingCount}}起</span>
            </div>
            <div class="line" v-if="DetailData">
              <span>投诉建议数</span>
              <span>{{DetailData.complaintingCount}}起</span>
            </div>
            <div class="line" v-if="DetailData">
              <span>电梯使用年限</span>
              <span>{{ DetailData.useAge }}年</span>
            </div>
          </div>
          <div
            class="content3"
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="#121D49"
          >
            <div class="tab tab-bottom-line">
              <ul>
                <li
                  :class="currentWBTabIndex==1?'item active':'item'"
                  @click="handleWBTab(1)"
                >维保物业信息</li>
                <li class="separator"></li>
                <li
                  :class="currentWBTabIndex==0?'item active':'item'"
                  @click="handleWBTab(0)"
                >维保最新状态</li>
              </ul>
            </div>
            <div class="tabContent">
              <div class="tabContentItem" v-if="currentWBTabIndex==1">
                <div class="line1">
                  <span>物业单位</span>
                  <span v-if="DetailData.manageUnit">{{ DetailData.manageUnit.orgName}}</span>
                </div>
                <div class="line1">
                  <span>物业联系人</span>
                  <span v-if="DetailData.manageUnit">{{ DetailData.manageUnit.linkMan}}</span>
                </div>
                <div class="line1">
                  <span>物业联系人电话</span>
                  <span v-if="DetailData.manageUnit">{{DetailData.manageUnit.linkTel}}</span>
                </div>
                <div class="line1">
                  <span>维保单位</span>
                  <span>{{DetailData.maintainUnit.orgName}}</span>
                </div>
                <div class="line1">
                  <span>维保单位联系人</span>
                  <span>{{DetailData.maintainUnit.linkMan}}</span>
                </div>
                <div class="line1">
                  <span>维保单位联系人电话</span>
                  <span>{{DetailData.maintainUnit.linkTel}}</span>
                </div>
              </div>
              <div class="tabContentItem" v-if="currentWBTabIndex==0 && DetailData">
                <div class="line1">
                  <span>本次维保时间</span>
                  <span>{{DetailData.lastMaintainTime ? DetailData.lastMaintainTime.substr(0, 19) : '' }}</span>
                </div>
                <!-- <div class="line1" v-if="DetailData">
                  <span>本次维保人员</span>
                  <span
                    v-for="item in DetailData.lastMaintainBy.lastMaintainBy"
                    :key="item.index"
                  >{{ item }}</span>
                </div>-->
                <div class="line1">
                  <span>本次维保类型</span>
                  <span>{{DetailData.lastMaintainType }}</span>
                </div>
                <div class="line1">
                  <span>本次维保说明</span>
                  <span>{{DetailData.lastMaintainRemark }}</span>
                </div>
                <div class="line1">
                  <span>下次维保时间</span>
                  <span>{{ DetailData.nextMaintainTime ? DetailData.nextMaintainTime.substr(0,10) : '' }}</span>
                </div>
                <div class="line1">
                  <span>下次年检时间</span>
                  <span>{{ DetailData.nextAnnualTime ? DetailData.nextAnnualTime.substr(0,10) : ''}}</span>
                </div>
                <div class="line1">
                  <span>维保过期数</span>
                  <span>{{DetailData.maintainDelayCount}}</span>
                </div>
                <div class="line1">
                  <span>年检过期数</span>
                  <span>{{DetailData.annualDelayCount}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div
          class="content"
          v-loading="loadingList"
          element-loading-spinner="el-icon-loading"
          element-loading-background="#121D49"
        >
          <el-scrollbar class="scroll" v-if="ViewData && CurData">
            <div class="line">
              <span>地区</span>
              <span>地址</span>
              <span>在线状态</span>
            </div>
            <div
              class="line"
              v-for="item in ViewData"
              :key="item.fixingID"
              @click="goDetail(item)"
              :class="getClass(item)"
            >
              <span>{{item.areaName}}</span>
              <span>{{item.buildCellNumber}}</span>
              <span>
                <img
                  :src="item.isOnline == false?'../../static/wifi-no.png':'../../static/wifi.png'"
                />
              </span>
            </div>
          </el-scrollbar>
          <button @click="back">返回</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import videojs from 'video.js'
import 'videojs-flash'
import 'video.js/dist/video-js.min.css'
import GLOBAL from '@/api/global_variable'
import DateUtils from '@/api/DateUtils'
import Video from '../components/video'
import moment from 'moment'
// eslint-disable-next-line no-unused-vars,no-unused-vars
let player = null
export default {
  name: 'EchartsView3',
  components: {
    'my-video': Video
  },
  data() {
    return {
      loadingVideo: true,
      loading: true,
      loadingList: true,
      ViewData: null,
      CurData: null,
      DetailData: { manageUnit: {} },
      StreamData: null,
      center: { lng: 0, lat: 0 },
      zoom: 3,
      show: false,
      markerPoint: { lng: 0, lat: 0 },
      mapStyle: { styleJson: [] },
      isVideoPlay: false, // 用于控制播放和暂停按钮
      rtmpUrl: '',
      timer: null,
      cTimer: null,
      dTimer: null,
      flat: 1,
      url: '',
      key: '', // 编号
      currentRunTabIndex: 0, // 运行状态tab
      currentWBTabIndex: 0, // 维保tab
      finxingId: 0,
      runData: {
        runstateStr: '未知',
        dahstateStr: '未知',
        floorstateStr: '未知',
        flatstateStr: '未知',
        doorstateStr: '未知',
        peoplestateStr: '未知',
        bicyclestateStr: '未知',
        currentpeopleStr: '未知',
        inpeopleStr: '未知',
        peoplesexscaleStr: '未知'
      }, // 运行数据
      videoId: null,
      serverUrl: null,
      message: null,
      token: null
    }
  },
  mounted() {
    GLOBAL.curPage = 3
    this.key = this.$route.query.key

    this.loadData(this.key)
    let that = this
    setTimeout(function() {
      that.loadMapStyle()
    }, 2000)
    // this.loadVideo()
  },
  beforeDestroy() {
    this.DetailData = null
    this.isVideoPlay = false
    this.rtmpUrl = null
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.dTimer) {
      clearInterval(this.dTimer)
    }
    this.timer = null
    this.dTimer = null
  },
  methods: {
    // handleRunTab: function(index) {
    //   this.currentRunTabIndex = index
    //   if (!this.dTimer) {
    //     let that = this
    //     this.dTimer = setInterval(function() {
    //       that.loadRunData()
    //     }, 2000)
    //   }
    // },
    getDate(date){
      if(!date)
      return '';
      const year = this.date.getFullYear();
      const month = ('0' + (this.date.getMonth() + 1)).slice(-2);
      const day = ('0' + this.date.getDate()).slice(-2);
      return `${year}${month}${day}`;
    },
    handleWBTab: function(index) {
      this.currentWBTabIndex = index
    },
    loadMapStyle: function() {
      this.axios
        .get('/static/custom_map_config.json')
        .then(res => {
          this.mapStyle.styleJson = res.data
        })
        .catch(err => {
          console.log(err)
        })
    },
    loadData: function(key) {
      if (!key) key = GLOBAL.defaultProj[0]
      let that = this
      this.loading = true
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId')
        },
        method: 'get',
        url: process.env.API_ROOT + '/Visual/fixing/item/' + key
      })
        .then(res => {
          that.ViewData = res.data.result
          if (that.ViewData.length > 0) {
            that.CurData = that.ViewData[0]
            that.loadDetailData(that.CurData.fixingId)
            that.getAccesstoken()
          }
          that.loading = false
          that.loadingList = false
          this.$forceUpdate()
        })
        .catch(err => {
          console.log(err)
        })

      // this.$ajax.get('http://open.tywliot.com/datacenter/GetList?keytype=' + GLOBAL.getKeyType() + '&key=' + key).then(res => {
      //   that.ViewData = res.data.Data
      //   if (that.ViewData.FixingList.length > 0) {
      //     that.CurData = that.ViewData.FixingList[0]
      //     that.loadDetailData(that.CurData.FixingID)
      //   } else {
      //     console.log(res.data.Data)
      //     that.loading = false
      //     that.isVideoShow = true
      //     that.loadingVideo = false
      //   }
      //   that.loading = false
      //   that.loadingList = false
      // }).catch(err => {
      //   console.log(err)
      // })
    },
    loadDetailData: function(key) {
      let that = this
      this.loading = true
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId')
        },
        method: 'get',
        url: process.env.API_ROOT + '/Visual/fixing/' + key
      })
        .then(res => {
          that.DetailData = res.data.result
          // if (that.DetailData.lastMaintainTime) {
          //   that.DetailData.lastMaintainTime = DateUtils.formatLongDate(new Date(that.DetailData.lastMaintainTime))
          // }
          // if (that.DetailData.nextMaintainTime) {
          //   that.DetailData.nextMaintainTime = DateUtils.formatLongDate(new Date(that.DetailData.nextMaintainTime))
          // }
          // if (that.DetailData.nextAnnualTime) {
          //   that.DetailData.nextAnnualTime = DateUtils.formatLongDate(new Date(that.DetailData.nextAnnualTime))
          // }
          if (that.DetailData.RescueCall) {
            var jsonObj = JSON.parse(that.DetailData.rescuecalls)
            that.DetailData.rescuecalls = jsonObj[0].value[0].callnum
            // console.log(that.DetailData.RescueCall)
            // for (var i = 0; i < jsonObj.length; i++) {
            //   console.log(jsonObj[i])
            // }
            // 运行数据
            that.finxingId = that.CurData.fixingID
            // that.url =
            //   'http://monitor.tywliot.com/general/CallCenter/animation/animationpage.aspx?fixingid=' +
            //   that.finxingId
            that.url = '/index2.html'
          }
          // 获取详情地址后  取消loading  显示video控件 取消下一次获取的timeout
          that.loading = false
          // document.getElementById('video_bg').style.display = 'none'
          // if (that.DetailData.GatewayID) {
          //   that.rtmpUrl = null
          //   clearTimeout(that.cTimer)
          // }
        })
        .catch(err => {
          console.log(err)
        })

      // this.$ajax.get('http://open.tywliot.com/datacenter/GetInfo?keytype=' + GLOBAL.getKeyType() + '&key=' + key).then(res => {
      //   that.DetailData = res.data.Data
      //   if (that.DetailData.RescueCall) {
      //     var jsonObj = JSON.parse(that.DetailData.RescueCall)
      //     that.DetailData.RescueCall = jsonObj[0].value[0].callnum
      //     // console.log(that.DetailData.RescueCall)
      //     // for (var i = 0; i < jsonObj.length; i++) {
      //     //   console.log(jsonObj[i])
      //     // }
      //     // 运行数据
      //     that.finxingId = that.CurData.FixingID
      //     that.url = 'http://monitor.tywliot.com/general/CallCenter/animation/animationpage.aspx?fixingid=' + that.finxingId
      //   }
      //   // 获取详情地址后  取消loading  显示video控件 取消下一次获取的timeout
      //   that.loading = false
      //   that.isVideoShow = true
      //   that.loadingVideo = false
      //   // document.getElementById('video_bg').style.display = 'none'
      //   // if (that.DetailData.GatewayID) {
      //   //   that.rtmpUrl = null
      //   //   clearTimeout(that.cTimer)
      //   // }
      // }).catch(err => {
      //   console.log(err)
      // })
    },
    async getAccesstoken() {
      this.message = '正在获取token'
      // const res = await accesstoken({ fixingid: this.fixingId }).catch(res => {
      //   this.message = res
      // })
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId')
        },
        method: 'get',
        url: process.env.API_ROOT + '/gateway/accesstoken?fixingid=' + this.CurData.fixingId
      }).then(res => {
        res = res.data
        console.log(res)
        if (
          res &&
          res.successed &&
          res.result &&
          res.result.server_ip &&
          res.result.access_token
        ) {
          this.message = '正在登录'
          this.serverUrl = res.result.server_ip
          this.token = res.result.access_token
          console.log('serverUrl=' + this.serverUrl)
          this.initWebSocket()
        } else {
          this.message = 'token 获取失败'
        }
      }).catch(err => {
        console.log(err)
      })
    },
    initWebSocket() {
      // 初始化weosocket
      if (this.serverUrl) {
        this.websock = new WebSocket(this.serverUrl)
        this.websock.onmessage = this.websocketonmessage
        this.websock.onopen = this.websocketonopen
        this.websock.onerror = this.websocketonerror
        this.websock.onclose = this.websocketclose
      }
    },
    websocketonopen() {
      // 连接建立之后 直接登录
      const actions = { token: this.token }
      this.websocketsend('login ' + JSON.stringify(actions))
    },
    websocketonerror() {
      // 连接建立失败重连
      console.log('on error')
      this.initWebSocket()
    },
    websocketonmessage(e) {
      // 数据接收
      if (e && e.data) {
        var command = e.data.substr(0, e.data.indexOf(' '))
        var content = e.data.substr(e.data.indexOf(' ') + 1, e.data.length)
        const rst = JSON.parse(content)
        if (command === 'Login') {
          // 登录返回
          if (rst.Successed) {
            this.message = '正在请求数据资源'
            this.isLogin = true
            this.reConnectionFlag = 0
            this.message = null
            this.sendDataRequestCommand()
          } else {
            this.message = '视频服务登录失败'
          }
        } else if (command === 'Data') {
          // 视频请求返回
          if (rst.Successed) {
            // 2播放
            // console.log(rst.Result)
            if (this.$refs.frameRef) {
              this.$refs.frameRef.contentWindow.setRunInfo(rst)
            }
          }
        }
        // console.log(JSON.parse(content))
      }
    },
    websocketsend(Data) {
      // 数据发送
      if (this.websock) {
        this.websock.send(Data)
      }
    },
    websocketclose(e) {
      // 关闭
      if (this.reConnectionFlag === 0) {
        this.reConnectionFlag = 1
        this.videoId = null
        console.log('断开连接', e)
        this.message = '连接断开，正在重连...'
        this.recordFlag = 0
        this.isLogin = false
        if (this.timer) {
          clearInterval(this.timer)
        }
        var that = this
        var interval = setInterval(function() {
          if (that.isLogin === true) {
            clearInterval(interval)
          } else {
            that.initWebSocket()
          }
        }, 3000)
      }
    },
    sendDataRequestCommand() {
      // 发送视频请求命令
      console.log('发送数据请求命令')
      var that = this
      this.timer = setInterval(function() {
        if (that.isLogin === true) {
          console.log('send data' + that.CurData.fixingId)
          const actions = { fixingid: that.CurData.fixingId }
          that.websocketsend('data ' + JSON.stringify(actions))
        }
      }, 2000)
      console.log(this.timer)
    },
    loadRunData: function() {
      let that = this
      this.$ajax
        .get(
          'http://open.tywliot.com/datacenter/GetAutomatism?keytype=' +
            GLOBAL.getKeyType() +
            '&key=' +
            this.finxingId
        )
        .then(res => {
          let data = res.data
          if (data.Ret === 0) {
            let value = data.Data.Values

            if (value.runstate !== null && value.runstate !== undefined) {
              that.runData.runstateStr =
                value.runstate === '0' ? '停止' : '运行'
            }
            if (value.dahstate !== null && value.dahstate !== undefined) {
              if (value.dahstate === '0') {
                that.runData.dahstateStr = '无'
              } else if (value.dahstate === '1') {
                that.runData.dahstateStr = '上'
              } else if (value.dahstate === '2') {
                that.runData.dahstateStr = '下'
              }
            }
            if (value.flatstate !== null && value.flatstate !== undefined) {
              that.runData.flatstateStr =
                value.flatstate === '0' ? '非平层' : '平层'
            }
            if (value.doorstate !== null && value.doorstate !== undefined) {
              if (value.doorstate === '0') {
                that.runData.doorstateStr = '关门'
              } else if (value.doorstate === '1') {
                that.runData.doorstateStr = '关门中'
              } else if (value.doorstate === '2') {
                that.runData.doorstateStr = '开门中'
              } else if (value.doorstate === '3') {
                that.runData.doorstateStr = '开门'
              }
            }
            if (value.floorstate !== null && value.floorstate !== undefined) {
              that.runData.floorstateStr = value.floorstate
            }
            if (value.peoplestate !== null && value.peoplestate !== undefined) {
              that.runData.peoplestateStr =
                value.peoplestate === '0' ? '无人' : '有人'
            }

            if (
              value.bicyclestate !== null &&
              value.bicyclestate !== undefined
            ) {
              that.runData.bicyclestateStr =
                value.bicyclestate === '0' ? '无' : '有'
            }
            if (
              value.currentpeople !== null &&
              value.currentpeople !== undefined
            ) {
              that.runData.currentpeopleStr = value.currentpeople
            }
            if (value.peoplecount !== null && value.peoplecount !== undefined) {
              that.runData.inpeopleStr = value.peoplecount
            }
            if (value.sexratio !== null && value.sexratio !== undefined) {
              that.runData.peoplesexscaleStr = value.sexratio
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    goDetail: function(item) {
      this.CurData = item
      this.videoId = null
      this.isVideoPlay = false
      // this.isVideoPlay = false
      // this.isVideoShow = false
      // this.loadingVideo = true
      // this.rtmpUrl = null
      // if (this.player) {
      //   this.player.pause()
      //   this.player.doReset_()
      //   // document.getElementById('video_bg').style.display = 'block'
      // }
      // // 取消获取流地址的timer
      // if (this.cTimer != null) {
      //   clearInterval(this.cTimer)
      // }
      // this.player = null
      // this.finxingId = this.CurData.fixingID
      this.loadDetailData(this.CurData.fixingId)

      //this.getAccesstoken()
      // this.loadDetailData(this.CurData.FixingID)
    },
    getClass: function(item) {
      if (item.fixingId === this.CurData.fixingId) {
        return 'selected'
      }
    },
    handler({ BMap, map }) {
      if (!this.$route.query.lng) {
        this.center.lng = GLOBAL.defaultProj[1]
        this.center.lat = GLOBAL.defaultProj[2]
        this.markerPoint.lng = GLOBAL.defaultProj[1]
        this.markerPoint.lat = GLOBAL.defaultProj[2]
      } else {
        this.center.lng = this.$route.query.lng
        this.center.lat = this.$route.query.lat
        this.markerPoint.lng = this.$route.query.lng
        this.markerPoint.lat = this.$route.query.lat
      }
      this.zoom = 14
      // 启用滚轮放大缩小
      map.enableScrollWheelZoom()

      setTimeout(function() {
        // 隐藏百度版权信息
        var objs = document.getElementsByClassName('BMap_cpyCtrl')
        for (var i = 0; i < objs.length; i++) {
          objs[i].style.display = 'none'
        }
        objs = document.getElementsByClassName('anchorBL')
        for (i = 0; i < objs.length; i++) {
          objs[i].style.display = 'none'
        }
      }, 2000)
    },
    back() {
      history.go(-1)
    },
    history() {
      this.$router.push({ path: '/history' })
    },
    infoWindowClose() {
      this.show = false
    },
    infoWindowOpen() {
      this.show = true
    },
    startVideo() {
      this.videoId = this.CurData.fixingId
      this.isVideoPlay = true
    },
    endVideo() {
      this.isVideoPlay = false
      this.videoId = null
    }
  }
}
</script>
<style lang="css" rel="stylesheet/scss"  scoped>
ul {
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0;
}
li {
  list-style: none;
  height: 100%;
  float: left;
}
.tab {
  width: 100%;
  height: 40px;
}

.tab-bottom-line {
  border-bottom: 1px solid #394f8e;
}
.tab-top-line {
  border-top: 1px solid #394f8e;
}
.tab .separator {
  width: 1px;
  background-color: #394f8e;
  height: -moz-calc(100% - 8px);
  height: -webkit-calc(100% - 8px);
  height: calc(100% - 8px);
  margin-top: 4px;
}
.tab .item {
  width: -moz-calc(50% - 1px);
  width: -webkit-calc(50% - 1px);
  width: calc(50% - 1px);

  color: #375375;
  cursor: pointer;
  line-height: 40px;
}
.tab .active {
  color: #6c89aa;
}
.tabContent {
  width: 100%;
  height: -moz-calc(100% - 40px);
  height: -webkit-calc(100% - 40px);
  height: calc(100% - 40px);
}
.tabContentItem {
  padding: 10px;
  width: 100%;
  height: 100%;
  display: block;
}
.elevator-frame{
  width: 100%;
  height: 100%;

}
.runInfoBox {
  width: 90%;
  height: 16%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
.runInfo {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.runInfo .runInfoLable {
  flex: 1;
  display: inline;
  text-align: left;
  color: #6c89aa;
}
.runInfo .runInfoValue {
  flex: 1;
  color: white;
}

.runInfoValueColor0 {
  color: #ff3333 !important;
}
.runInfoValueColor1 {
  color: #80ff9b !important;
}
.runAnimationframe {
  width: 100%;
  height: 100%;
}
.el-loading-mask {
  background-color: transparent;
}
.container {
  width: 100%;
  height: calc(100% - 40px);
  background: #0b133f;
}
.bottom {
  height: calc(100% - 100px);
  width: 99%;
  display: inline-flex;
}
.bottom .left {
  width: 76%;
  height: 100%;
}
.bottom .right {
  width: 24%;
  height: 100%;
}
.bottom .left .row1 {
  width: 100%;
  height: 65%;
  display: inline-flex;
}
.bottom .left .row1 .image {
  height: 98%;
  width: 28%;
  background: #121d49;
  margin: 1%;
  border-radius: 6px;
}
.bottom .left .row1 .image .content {
  width: 96%;
  height: 96%;
  margin: 2%;
  border-radius: 4px;
}
.bottom .left .row1 .video {
  height: 98%;
  width: 70%;
  background: #121d49;
  margin: 1%;
  border-radius: 6px;
}
.bottom .left .row1 .video .content {
  width: 98%;
  height: 86%;
  margin: 1%;
  background: #000;
  border-radius: 4px;
}
.bottom .left .row1 .video img {
  width: 50px;
  height: 50px;
  cursor: pointer;
}
.bottom .left .row2 {
  height: 35%;
  width: 100%;
  display: inline-flex;
}
.bottom .left .row2 .content1 {
  background: #121d49;
  width: 50%;
  margin: 1%;
  border-radius: 4px;
}
.bottom .left .row2 .content2 {
  background: #121d49;
  width: 20%;
  margin: 1%;
  border-radius: 4px;
}
.bottom .left .row2 .content3 {
  background: #121d49;
  width: 32%;
  margin: 1%;
  border-radius: 4px;
}
.bottom .left .row2 .title {
  width: 100%;
  color: #fff;
  height: 40px;
  line-height: 40px;
  text-align: left;
  font-size: 18px;
  display: block;
  padding-left: 5%;
  letter-spacing: 2px;
}
.bottom .left .row2 .line {
  height: 32px;
  width: 97%;
  color: #6c89aa;
  font-size: 14px;
  display: inline-flex;
  padding-left: 2%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bottom .left .row2 .line span {
  display: block;
  height: 32px;
  line-height: 32px;
  text-align: left;
}
.bottom .left .row2 .line span:nth-child(odd) {
  width: 20%;
}
.bottom .left .row2 .line span:nth-child(even) {
  width: 30%;
}
.bottom .left .row2 .line span:nth-child(2) {
  width: 25%;
}
.bottom .left .row2 .line1 {
  height: 28px;
  width: 100%;
  color: #6c89aa;
  font-size: 14px;
  display: inline-flex;
  padding-left: 5%;
}
.bottom .left .row2 .line1 span {
  display: block;
  height: 26px;
  line-height: 26px;
  text-align: left;
}
.bottom .left .row2 .line1 span:first-child {
  width: 45%;
}
.bottom .left .row2 .line1 span:last-child {
  width: 50%;
  white-space: nowrap;
  overflow: hidden;
}

.right .content {
  margin: 3%;
  height: 98%;
  width: 92%;
  background: #121d49;
  border-radius: 6px;
}
.right .content .scroll {
  height: calc(100% - 40px);
  width: 100%;
  overflow: hidden;
}
/*.scroll::-webkit-scrollbar {*/
/*  width: 14px;*/
/*}*/
/*.scroll::-webkit-scrollbar-thumb {*/
/*  background-color:#d9d9d9;*/
/*}*/
.right .content .line {
  width: 100%;
  height: 32px;
  display: inline-flex;
  cursor: pointer;
}

.right .content .selected {
  background: #ecf5ff;
}
.right .content .line span {
  color: #6c89aa;
  display: block;
  width: 20%;
  font-size: 14px;
  height: 32px;
  line-height: 32px;
}
.right .content .line span:nth-child(2) {
  width: 55%;

  white-space: nowrap;
  overflow: hidden;
}
.right .content .line span:nth-child(3) {
  width: 25%;
}
.right .content .line span img {
  width: 20px;
  height: 20px;
  margin-top: 6px;
}
.map {
  height: 100%;
  width: -moz-calc(100% - 16px);
  width: -webkit-calc(100% - 16px);
  width: calc(100% - 16px);
  height: -moz-calc(100% - 16px);
  height: -webkit-calc(100% - 16px);
  height: calc(100% - 16px);
  margin: 0 auto;
  margin-top: 8px;
}
#zoomer {
  display: none;
}
.map span {
  display: none;
}
.map .anchorBL {
  display: none !important;
  position: absolute;
}
.BMap_cpyCtrl {
  display: none;
}
button {
  padding: 6px 20px 6px 20px;
  border-radius: 8px;
  border: 1px solid #1f4687;
  background: #172351;
  color: #fff;
  margin-top: 4px;
  cursor: pointer;
}
.video .context .el-loading-mask {
  opacity: 0.7;
}

.video-bg {
  width: 100%;
  height: 100%;
  background: url('/static/video-bg.png');
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/EchartsView3.vue